import { styled, Text, TextTag } from "@volkswagen-onehub/components-core";
import React from "react";
import { getContrastColor } from "../utils/get-contrast-color";

interface TagProps {
  bgColor: string;
};

const StyledTagWrapper = styled.div<TagProps>`
  display: flex;
  gap: ${({ theme }) => theme.size.static100};
  align-items: center;
  // width: fit-content;
  // height: ${({ theme }) => theme.size.static350};
  background-color: ${({bgColor}) => bgColor};
  color: ${({bgColor}) => getContrastColor(bgColor)};
  /* padding: 0 ${({ theme }) => theme.size.static150}; */
  p {
    margin-top: ${({ theme }) => theme.size.static0};
    ::first-letter {
      text-transform: uppercase;
    }
  }
  border-radius: 4px;
`;

interface Props {
  text: string;
  bgColor: string;
  bold?: boolean;
}

export const CustomTag = ({
  bgColor,
  text,
  bold
}: Props) => {
  return (
    <StyledTagWrapper bgColor={bgColor}>
      <Text tag={TextTag.p} bold={bold ? bold : false}>
        { text }
      </Text>
    </StyledTagWrapper>
  );
};
